import GetCustomer from "./GetCustomer";
import ShopifyCreateMultipassToken from "./ShopifyCreateMultipassToken";
import ShopifyCreateCustomerAccessTokenWithMultipass from "./ShopifyCreateCustomerAccessTokenWithMultipass";

const getTokenByUserId = async (userId) => {
  try {
    const { email } = await GetCustomer(userId);
    const multipassToken = await ShopifyCreateMultipassToken(email);
    const accessToken = await ShopifyCreateCustomerAccessTokenWithMultipass(multipassToken);
    if (accessToken) {
      sessionStorage.setItem("sup_token", accessToken);
    }
    return accessToken;
  } catch (e) {
    console.log(e);
  }
};

export default getTokenByUserId;
